type RGBValue = {
    r: number
    g: number
    b: number
}

/**
 * Returns a hex string forced to be the full 6 characters. (ex. #ffffff)
 */
export const normalizeHexLength = (hex: string): string => {
    const color = hex.replace(/#/g, '')
    if (color.length === 3) {
        let longhand = ''
        color.split('').forEach(value => {
            longhand += `${value}${value}`
        })
        return `#${longhand}`
    }
    return `#${color}`
}

/**
 * Converts a hex color value to rgb.
 * @param hex Hex color to convert.
 */
export const hexToRgb = (hex: string): RGBValue => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(normalizeHexLength(hex))
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : { r: 0, g: 0, b: 0 }
}

/**
 * Returns a css background value based on a color string (can be comma separated to make gradient)
 * @param color Hex color string (can be comma separated)
 * @returns
 */
export const getCssBackgroundFromColorString = (color: string = ''): string => {
    if (color.indexOf(',') > -1) {
        const values = color.split(',')
        const gradientValues = values.map((value, i) => `${value} ${Math.round((i / (values.length - 1)) * 100)}%`)
        return `linear-gradient(45deg, ${gradientValues.join(', ')})`
    }

    return color
}
